import { extractContainerTypesFromURI, extractShippingLinesFromURI } from 'ducks/erlData';
import { globalLoaderSelector } from 'ducks/loader';
import { isLogged } from 'ducks/user';
import { connect, RootStateOrAny } from 'react-redux';
import { compose } from 'redux';
import FreeTable from './FreeTable';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: RootStateOrAny, ownProps: any) => ({
  isLoading: globalLoaderSelector(state),
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  containerTypes: extractContainerTypesFromURI(state, ownProps),
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  shippingLines: extractShippingLinesFromURI(state, ownProps),
  isLogged: isLogged(),
});

export default compose(connect(mapStateToProps))(FreeTable);
